import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventoListModalComponent } from './evento-list-modal.component';
import { SharedModule } from '../../shared.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [EventoListModalComponent],
  imports: [
    CommonModule, SharedModule, ReactiveFormsModule
  ]
})
export class EventoListModalModule { }
